import React, { useEffect, useState } from 'react';
import { Box, Typography, Avatar, Paper, Rating, CircularProgress } from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';
import { urlImg } from '../../common/helpers';
import { getProviderReviews } from '../../../actions/reviews';

moment.locale('es');

const PageComments = ({ proveedorId, providerName }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!proveedorId) return;
    setLoading(true);
    getProviderReviews(proveedorId).then((data) => {
      setReviews(data || []);
      setLoading(false);
    });
  }, [proveedorId]);

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, color: '#0E2465', mb: 0.5 }}>
        Comentarios destacados
      </Typography>
      <Typography variant="body2" sx={{ color: '#64748B', mb: 2 }}>
        {reviews.length > 0
          ? `${reviews.length} opinión${reviews.length !== 1 ? 'es' : ''} sobre el trabajo de ${providerName || 'el profesional'}`
          : `Opiniones sobre el trabajo de ${providerName || 'el profesional'}`}
      </Typography>

      {loading ? (
        <Box sx={{ textAlign: 'center', py: 3 }}>
          <CircularProgress size={28} sx={{ color: '#7495f8' }} />
        </Box>
      ) : reviews.length === 0 ? (
        <Paper elevation={0} sx={{ p: 3, borderRadius: '16px', bgcolor: '#F8FAFC', border: '1px solid #E2E8F0', textAlign: 'center' }}>
          <Typography variant="body2" color="#64748B">
            Aún no hay comentarios para este proveedor.
          </Typography>
        </Paper>
      ) : (
        reviews.map((review) => {
          const cliente = review.cliente || {};
          const nombre = cliente.name ? `${cliente.name} ${cliente.apellido || ''}`.trim() : 'Usuario';
          const avatarSrc = cliente.avatar
            ? `${urlImg}/users/${cliente._id}/${cliente.avatar}?v=${cliente.versionAvatar || 0}`
            : null;

          return (
            <Paper key={review._id} elevation={0} sx={{ p: 2, mb: 2, borderRadius: '16px', bgcolor: '#F8FAFC', border: '1px solid #E2E8F0' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
                  <Avatar src={avatarSrc} sx={{ bgcolor: '#0E2465', width: 32, height: 32, fontSize: '0.8rem' }}>
                    {!avatarSrc && nombre.charAt(0)}
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0E2465' }}>{nombre}</Typography>
                    <Typography variant="caption" sx={{ color: '#94A3B8' }}>
                      hace {moment(review.createdAt).fromNow(true)}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Typography variant="caption" sx={{ fontWeight: 700, color: '#0E2465' }}>{review.rating}</Typography>
                  <Rating value={review.rating} readOnly size="small" sx={{ fontSize: '1rem', color: '#0E2465' }} />
                </Box>
              </Box>
              {review.comentario && (
                <Typography variant="body2" sx={{ color: '#475569', lineHeight: 1.5 }}>
                  {review.comentario}
                </Typography>
              )}
            </Paper>
          );
        })
      )}
    </Box>
  );
};

export default PageComments;
